<template>
  <dialog-big
    :visible.sync="isVisible"
    :title="L10n('add-supplier-quote')"
    :closeOnClickModal="false"
    @close="setCommand('cancel')"
    :isLoading="isLoading"
  >
    <more-quotes-grid-chosen
      :listSelectedQuotes="listSelectedQuotes"
    />
    <more-quotes-grid
      ref="more-quotes-grid"
      :data="dataRFQ2"
      :listSelectedQuotes.sync="listSelectedQuotes"
    />
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        isCancel
        isCreate
        @command="commandController"/>
    </template>
  </dialog-big>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import { api } from '@/services/api'

export default {
  name: 'ModalNew',
  mixins: [FormWrapper],
  components: {
    'dialog-big': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/DialogBig'),
    'more-quotes-grid': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQSupplierMoreQuotesGrid/Index.vue'),
    'more-quotes-grid-chosen': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQSupplierMoreQuotesGridChosen/Index.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object },
    dataRFQ2: { type: Object }
  },
  data () {
    return {
      listSelectedQuotes: []
    }
  },
  watch: {
    isVisible () {
      this.$bus.$emit('update-supplier-more-quotes')
    }
  },
  methods: {
    commandController (command) {
      if (command === 'save') {
        this.validate()
          .then(() => {
            this.addNewItems()
          })
          .catch((err) => {
            this.validateErrorHandler(err)
          })
      } else {
        this.setCommand(command)
      }
    },
    addNewItems () {
      this.isLoading = true
      return Promise
        .all(this.listSelectedQuotes.map((item) => {
          return this.updateSelectedRFQ2(item)
            .then(() => {
              return this.createRFQ1(item)
            })
        }))
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .then(() => {
          this.isLoading = false
          this.listSelectedQuotes = []
          this.$refs['more-quotes-grid'].getGrid().requestGetDataDebounce()
          this.setCommand('cancel')
          this.$emit('on-added-items')
        })
    },
    updateSelectedRFQ2 (data) {
      let url = `RFQ2s/Patch/${data.id}`
      let requestData = { id: data.id, chosen: true, rfqid: this.dataRFQ2.rfqid }
      return api
        .patch(url, requestData)
    },
    createRFQ1 (data) {
      let dataResponse = {
        rfqid: this.dataRFQ2.rfqid,
        qty: data.qty,
        partID: data.partID
      }
      return api
        .post(`RFQ1s/Create`, dataResponse)
    },
    validate () {
      return new Promise((resolve, reject) => {
        if (this.listSelectedQuotes.length) {
          resolve()
        } else {
          reject(new Error(this.L10n('chose-part')))
        }
      })
    }
  }
}
</script>
